import { useEffect } from 'react'
import { SENTRY_DSN } from '../constants'
import * as Sentry from '@sentry/react'
import { isAxiosError } from 'axios'
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom'
import { REFRESH_TOKEN_PATH } from '../api/api'
import posthog from './posthog'

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    attachStacktrace: true,
    environment: import.meta.env.VITE_ENVIRONMENT,
    release: APP_VERSION,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.extraErrorDataIntegration({
        depth: 10,
      }),
      posthog.sentryIntegration({
        organization: import.meta.env.VITE_SENTRY_ORG,
        projectId: Number(import.meta.env.VITE_SENTRY_PROJECT_ID),
        severityAllowList: ['error', 'fatal'],
      }),
    ],
    tracePropagationTargets: [/^https:\/\/.*\.approveit\.today/],
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (isAxiosError(error)) {
        if (error.response?.status === 401 && !error.config?.url?.includes(REFRESH_TOKEN_PATH)) {
          return null
        }
      }

      return event
    },
  })
}
